(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ImageStorageDeleteController',ImageStorageDeleteController);

    ImageStorageDeleteController.$inject = ['$uibModalInstance', 'entity', 'ImageStorage'];

    function ImageStorageDeleteController($uibModalInstance, entity, ImageStorage) {
        var vm = this;

        vm.imageStorage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ImageStorage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
